import { initialValues } from '@Pages/Auth/containers/RegisterContainer';
import { useFormikContext } from 'formik';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export default function useRegisterStep2() {
	const [loading, setLoading] = useState(false);
	const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined);
	const formik = useFormikContext<typeof initialValues>();
	const { handleSubmit } = formik;
	const intl = useIntl();

	const HandleValidate2 = () => {
		const { values } = formik;
		if (
			values.password === '' ||
			values.confirmpassword === '' ||
			values.acceptTerms === false ||
			values.email === ''
		) {
			formik.setTouched({
				password: true,
				confirmpassword: true,
				acceptTerms: true,
				email: true,
			});
			formik.errors.confirmpassword;
			formik.errors.password;
			formik.errors.acceptTerms;
			formik.errors.email;
		}
	};

	return {
		loading,
		intl,
		hasErrors,
		handleSubmit,
		formik,
		HandleValidate2,
		setLoading,
	};
}
